import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { GardenScene } from "@/components/garden/GardenScene";
import { svgToPngBlob } from "@/lib/gardenShare";

// Builds a picture of the whole year's garden for the year video; returns [garden, hiddenSceneNode]
export const useYearGarden = (y) => {
  const ref = useRef(null);
  const [data, setData] = useState(null);
  const [garden, setGarden] = useState(null);
  useEffect(() => {
    const keys = y.months.map((m) => m.month_key);
    api.get("/garden/range", { params: { start: keys[0], end: keys[keys.length - 1] } }).then((r) => setData(r.data)).catch((e) => logError("Year garden failed:", e));
  }, [y]);
  useEffect(() => {
    const c = data?.counts;
    if (!c || !ref.current || !(c.flowers + c.golden + c.friends)) return;
    svgToPngBlob(ref.current, 1200).then((b) => {
      const img = new Image();
      img.onload = () => setGarden({ img, counts: c });
      img.src = URL.createObjectURL(b);
    }).catch((e) => logError("Year garden image failed:", e));
  }, [data]);
  const node = data ? createPortal(<div className="fixed -left-[9999px] top-0 w-[800px]" aria-hidden><GardenScene ref={ref} data={data} /></div>, document.body) : null;
  return [garden, node];
};
